<template>
  <vuedraggable  class="task-list-curr" handle=".task-drag-box-icon" element="div" v-bind="dragOptions()" :list="list" @update="end" @add="end" :data-group="group" :data-pid="pid" @sort="sortChange" :data-key="groupKey" :class="{'task-list-curr__none': groupKey === 'level4' && Object.keys(list).length === 0}" :style="{'width': headerWidth + 'px'}">
    <div v-for="item in list"  :key="item.id" :data-id="item.id" :data-check="isCheckStatus && item.check && item.task_level === 1" :class="{'is-check': isCheckStatus && item.check && item.task_level === 1, 'is-check-disabled': isCheckStatus && item.task_level === 1}" class="child-box" @click="checkItem(item)">
      <template v-if="item.id">
        <div class="table-line---tr" ref="table-line---tr"  :data-rule="item.sort_rule_id" :data-id="item.id" :class="{ 'complate-style': item.task_stage === '已完成', 'tr-active':activeId === item.id, 'readonly-style': isReadonly(item)}" @click="activeTr(item.id)">
          <div ref="task-title" class="table-line---item table-line---item-name table-line-item---in--fixed" :style="{ width: lineBox.width + 'px' }">
            <div class="table-line-item---in" :style="{'padding-left': item.task_level * 24 + 30 + 'px'}">
              <div class="dot" :style="{ visibility: item.unread_message_count > 0 ? 'visible' : 'hidden' }"></div>
              <div  class="group-drag-box-icon task-drag-box-icon" @mousedown="dragIsCan">
                <i v-if="isAdmin && !isReadonly(item) && !isCheckStatus && !ganttType && groupKey !== 'compete' && !isDisabledProject" class="icon iconfont iconicon_drag_order tableIconHover drag-icon"></i>
              </div>
              <div class="up-arrow" :style="{ visibility: item.all_children_task_count > 0 ? 'visible' : 'hidden' }" @click.stop="openChildren(item)">
                <i class="el-icon-loading" v-if="item.childLoading"></i>
                <span v-else>
                  <i class="icon iconfont iconicon_drop_down_arrow tableIconHover" :class="{'rota90': item.open}"></i>
                </span>
              </div>
              <el-checkbox :disabled="!item.edit_permission || isReadonly(item) || isCheckStatus || isDisabledProject" :checked="item.task_stage === '已完成' || item.before_archiving_is_completed" class="status-check" @change="taskStatusChange(item)" :key="item.id" :data-id="item.id">
              </el-checkbox>
              <div @click="taskClick(item)" class="table-line-item---title">
                <toolTip :title="item.task_name" :max-width="`calc(${item.all_children_task_count > 0 ? '100% - 46px' : '100%'} )`" :isOver.sync="item.isOver" :class="{'tool-tip-flex': item.isOver}">
                  <span :class="{'font-weight-style': item.task_level === 1}">{{ item.task_name }}</span>
                </toolTip>
                <div class="count" v-if="item.all_children_task_count > 0">{{ item.finish_children_task_count }}/{{ item.all_children_task_count }}</div>
              </div>
              <div class="task-sn" v-if="!isDisabledProject">
                <div class="task-sn-nore" @click="stopde" v-if="!isCheckStatus" :class="{'visibleActive-task-sn': item.show && isReadonly(item)}">
                  <el-dropdown @command="handleCommand" size="small" trigger="click" v-model="show" @visible-change="changeListShow(item)">
                    <span class="task-sn-hover">
                      <i class="icon iconfont iconicon_more_task1 tableIconHover"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item class="task-drop-item" :command="{ type: 'archive', item }" v-if="item.archive_permission"><i class="icon iconfont iconicon_move"></i>归档</el-dropdown-item>
                      <el-dropdown-item class="task-drop-item" :command="{ type: 'unarchive', item }" v-if="item.activate_archived_tasks_permission"><i class="icon iconfont iconicon_restore"></i>恢复未归档</el-dropdown-item>
                      <el-dropdown-item class="task-drop-item" :command="{ type: 'unFollow', item }" v-if="item.is_attention"><i class="icon iconfont iconicon_following"></i>取消关注</el-dropdown-item>
                      <el-dropdown-item class="task-drop-item" :command="{ type: 'follow', item }" v-else><i class="icon iconfont iconicon_focus_on"></i>关注</el-dropdown-item>
                      <el-dropdown-item class="task-drop-item border" :command="{ type: 'del', item }" v-if="item.delete_permission"><i class="icon iconfont iconicon_recycle_bin"></i>移至回收站</el-dropdown-item>
                    </el-dropdown-menu>

                    <!-- <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item class="task-drop-item" :command="{ type: 'archive', item }" v-if="item.archive_permission && isReadonly"><i class="icon iconfont iconicon_move"></i>归档</el-dropdown-item>
                      <el-dropdown-item class="task-drop-item" :command="{ type: 'unarchive', item }" v-if="item.activate_archived_tasks_permission && !isReadonly"><i class="icon iconfont iconicon_restore"></i>恢复未归档</el-dropdown-item>
                      <el-dropdown-item class="task-drop-item" :command="{ type: 'unFollow', item }" v-if="item.is_attention"><i class="icon iconfont iconicon_following"></i>取消关注</el-dropdown-item>
                      <el-dropdown-item class="task-drop-item" :command="{ type: 'follow', item }" v-else><i class="icon iconfont iconicon_focus_on"></i>关注</el-dropdown-item>
                      <el-dropdown-item class="task-drop-item border" :command="{ type: 'del', item }" v-if="item.delete_permission"><i class="icon iconfont iconicon_recycle_bin"></i>移至回收站</el-dropdown-item>
                    </el-dropdown-menu> -->
                  </el-dropdown>
                </div>
              </div>
              <i class="icon iconfont iconicon_enlarge tableIconHover add-icon" @click.stop="addTask(item)" v-if="item.edit_permission && !isCheckStatus && !isReadonly(item) && item.task_level < 3 && !isDisabledProject"></i>
            </div>
          </div>
          <div ref="task-title" class="table-line---item table-line---item-name" :style="{ width: lineBox.width + 'px' }"></div>
          <template v-if="autoKey">
            <!-- 截止日期 -->
            <div class="table-line---item" :style="{'min-width': comBase('RangeTime').width + 'px'}">
              <component :is="'RangeTime'" :readonly="!item.edit_permission || isReadonly(item) || isCheckStatus || isDisabledProject" v-model="item.timeRange" :defaultValue="[item.start_time, item.end_time]" @change="dataSend(item, 'time')" :onlyValue="true"></component>
            </div>
            <!-- 优先级 -->
            <div class="table-line---item" :style="{'min-width': comBase('LevelStatus').width + 'px'}">
              <component :is="'LevelStatus'" :readonly="!item.edit_permission || isReadonly(item) || isCheckStatus || isDisabledProject"  v-model="item.sort_rule_id" @change="dataSend(item, 'sort')" :sortList="sortList" :onlyValue="true"></component>
            </div>
            <!-- 执行人 -->
            <div class="table-line---item" :style="{'min-width': comBase('Executor').width + 'px'}">
              <component :is="'Executor'" :readonly="!item.edit_permission || isReadonly(item) || isCheckStatus || isDisabledProject"  v-model="item.executor_user" :defaultValue="item.executor_user" :projectId="projectId" @change="dataSend(item, 'executor')" :onlyValue="true"  :user_in_parent_tasks_permission="item.user_in_parent_tasks_permission"></component>
            </div>
            <!-- 参与人 -->
            <div class="table-line---item" :style="{'min-width': comBase('Participant').width + 'px'}">
              <component :is="'Participant'" isTags :readonly="!item.edit_permission || isReadonly(item) || isCheckStatus || isDisabledProject" :ref="'ParticipantTemp' + item.id" v-model="item.task_members_user" :defaultValue="item.task_members_user" :projectId="projectId" :onlyValue="true" @change="dataSend(item, 'task_members_user')" :lockUid="item.executor ? [item.executor] : []" :width="comBase('Participant').width"></component>
            </div>
            <template v-for="temp in item.template.template_standard_components">
              <div class="table-line---item" :key="temp.id" :style="{'min-width': com(temp.id).width + 'px'}">
                <component :isEdit="true" :is="temp.component_code" :projectId="projectId" v-model="temp.value" :config="getTempConfig(temp)" :defaultValue="getTemplateDefaultValue(temp)" :key="temp.id" :readonly="!item.edit_permission || isReadonly(item) || isCheckStatus || isDisabledProject" :onlyValue="true" @change="valueChange(item, temp)" :isTaskDetail="true" :isComplete="item.task_stage === '已完成'" :width="comBase('Participant').width" isTags></component>
              </div>
            </template>
          </template>
        </div>
        <template v-for="(val, key) in item.tasks">
          <List  v-if="typeof val === 'object' && val && val.length > 0 && item.open" :key="key" :list="val" :pid="pushPid(item.id)" :lineBox="lineBox" :pageMsg="pageMsg" :group="group" :taskList="taskList" :activeId="activeId" :autoKey="autoKey" :projectId="projectId" :sortList="sortList" :templateKey="templateKey" :groupKey="key" :headerWidth="headerWidth"></List>
        </template>
      </template>
    </div>
  </vuedraggable>
</template>
<script>
import vuedraggable from 'vuedraggable'
import api from '@/services/api/task/task'
import { mapMutations, mapActions, mapState } from 'vuex'
import bus from '@/bus'
import followApi from "@/services/api/follow/follow";
export default {
  name: 'List',
  components: {
    vuedraggable,
  },
  props: {
    pid: {
      type: [ String ],
      default: ''
    },
    taskList: {
      type: Array,
      default: () => {
        return []
      }
    },
    group: {
      type: Number,
      default: 0
    },
    list: {
      type: [Array, Object],
      default: () => {
        return []
      }
    },
    lineBox: {
      type: Object,
      default: () => { }
    },
    pageMsg: {
      type: Object,
      default: () => { }
    },
    activeId: {
      type:[String, Number],
      default: () => {}
    },
    autoKey: {
      type: Boolean,
      default: true
    },
    projectId: [String,Number],
    sortList: {
      type: Array,
      default: () => []
    },
    templateKey: {
      type: Array,
      default: () => []
    },
    groupKey: {
      type: String,
      default: () => 'list'
    },
    pid: {
      type: String,
      default: () => ''
    },
    headerWidth: {
      type: [Number],
      default: 100
    }
  },
  computed: {
    ...mapState('task/task', {
      queryMsg: state => state.queryMsg,
      isCheckStatus: state => state.isCheckStatus,
      checkTask: state => state.checkTask,
      timer: state => state.timer,
      ganttType: state => state.ganttType,
      isDisabledProject: state => state.isDisabledProject
    }),
    com() {
      return (id) => {
        return this.templateKey.find(res => res.id === id) || {}
      }
    },
    comBase() {
      return (key) => {
        return this.templateKey.find(res => res.key === key)
      }
    },
  },
  watch: {
    isCheckStatus() {
      if(this.isCheckStatus) {
        bus.$emit('activeTr', '')
      }
    },
    checkTask: {
      handler() {
        this.debounce(this.selectLine, 10)
      },
      deep: true,
    },
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {
  },
  methods: {
    ...mapMutations('task/task',['CHANGE_TASK','set_checkTask','set_checkBox', 'set_timer']),
    ...mapActions('task/task', ['editTask', 'updateKeyValue', 'updateFormKey', 'updateStatus','delTask']),
    isReadonly(item) {
      return item.task_stage === '已归档'
    },
    async end(event) {
      // 在数据集合中去获取值信息
      // console.log(event, this.taskList, this.list);
      if(!this.pid) {
        let from_id = event.from.dataset.group;
        let to_id = event.to.dataset.group;
        let task_list_id = '';
        let previous_task_id = '';
        let task_id = event.item.dataset.id * 1;
        let key = event.from.dataset.key;
        let dataset
        if (from_id !== to_id) {
          dataset = this.taskList.find((res) => res.task_list_id == to_id)
          task_list_id = to_id;
        } else {
          dataset = this.taskList.find((res) => res.task_list_id == from_id)
        }
        console.log(this.taskList, this.group, event.from.dataset.group, event.to.dataset.group, dataset)
        previous_task_id = event.newIndex - 1 < 0 ? 0 : dataset.tasks[key][event.newIndex - 1].id
        let params = {
          task_id,
          previous_task_id,
        };
        task_list_id ? (params.task_list_id = task_list_id) : '';
        api.updateTaskSort(params).then((res) => {
          this.$message({
            message: '修改成功',
            type: 'success',
          });
        });

      } else {
        let task_id = event.item.dataset.id * 1;
        let index = this.list.findIndex(res => res.id == task_id)
        let previous_task_id = index - 1 < 0 ? 0 : this.list[event.newIndex - 1].id
        let params = {
          task_id,
          previous_task_id,
        };
        api.updateTaskSort(params).then((res) => {
          this.$message({
            message: '修改成功',
            type: 'success',
          });
        });
      }
    },
    dragOptions() {
      return {
        animation: 200,
        group: this.groupKey
      }
    },
    async taskStatusChange(val) {
      let task_stage = val.task_stage === '已完成' ? '进行中' : '已完成'
      await api.updateTaskStage({ task_id: val.id, task_stage })
      // bus.$emit('updateTask', {task_id: val.id, task_list_id: val.task_list_id})
      bus.$emit('updateTask')
    },
    getTempConfig(item) {
      let params = {
        ...item.component_config_in_template,
        component_desc_in_template: item.field_desc,
        component_name_in_template: item.field_name,
        component_code: item.component_code,
      };
      return params;
    },
    getTemplateDefaultValue(row) {
      if (row.component_code === "TaskComponent.Attachment.Attachment") {
        return row.component_values;
      } else {
        return row.value ? row.value : row.component_values;
      }
    },
    async valueChange(temp, data) {
      console.log(temp, data)
      await this.updateKeyValue({ task_id: temp.id, data: data, temp })
        .then((res) => {
          this.$message({
            message: '修改成功',
            type: "success",
          });
          console.log(temp);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async dataSend(data, type) {
      let params = {};
      if (type === "executor" && data.executor) {
        data.executor = data.executor_user.uid
        this.changeRunMan(data);
      } else if (type === "time") {
        data.start_time = data.timeRange ? data.timeRange[0] : "";
        data.end_time = data.timeRange ? data.timeRange[1] : "";
      }
      params.start_time = data.timeRange ? data.timeRange[0] : "";
      params.end_time = data.timeRange ? data.timeRange[1] : "";
      params.sort_rule_id = data.sort_rule_id ? data.sort_rule_id : "";
      params.task_members = data.task_members_user ? data.task_members_user.map(res => res.uid) : "";
      params.executor = data.executor ? data.executor : 0;
      await this.updateFormKey({ task_id: data.id, data: params })
      this.$message({
        message: "修改成功",
        type: "success",
      });
    },
    changeRunMan(item) {
      if(!item.executor) return
      if (!item.task_members_user.find(res => res.uid === item.executor_user.uid)) {
        item.task_members_user.push(item.executor_user)
      }
    },
    taskClick(item) {
      if(this.isCheckStatus) return
      let task_id = item.id
      let task_group_id = item.task_group_id
      item.unread_message_count = 0
      this.CHANGE_TASK({ visible: true, task_id, task_group_id })
    },
    async openChildren(item) {
      this.$set(item, 'open', !item.open)
      if (!item.tasks || item.tasks.length === 0) {
        this.$set(item, 'childLoading', true)
        this.$set(item, 'childParams', {
          offset: 0,
          limit: 100,
          isFinish: false
        })
        let queryMsg = {
          ...this.queryMsg
        }
        queryMsg.sorting_rules = JSON.stringify(queryMsg.sorting_rules || [])
        let params = {
          page: item.childParams.offset,
          number: item.childParams.limit,
          parent_task_id: item.id,
          task_stage: this.pageMsg.task_stage,
          ...queryMsg
        }
        let result = await api.childrenTasksIndex(params)
        // if (result.length < item.childParams.limit) {
        //   item.childParams.isFinish = true
        // }
        this.$set(item, 'tasks', this.groupToArrayByValue(result.data).result)
        this.$set(item, 'childLoading', false)
        this.$nextTick(() => {
          this.selectLine()
        })
      }
    },
    groupToArrayByValue(arrData) {
      let result = {
        level4: [],
        level3: [],
        level2: [],
        level1: [],
      };
      let count = 0;
      arrData.forEach((item) => {
        count += item.unread_message_count > 0 ? 1 : 0;
        result.isTitleEdit = false;
        result["level" + item.sort_rule.sort] ? result["level" + item.sort_rule.sort].push(item) : (result["level" + item.sort_rule.sort] = [item]);
      });
      return { result, count };
    },
    pushPid(id) {
      if (this.pid) {
        return this.pid + ',' + id
      } else {
        return id.toString()
      }
    },
    sortChange(e) {
      console.log(e)
    },
    onMove(e) {

    },
    addTask(item) {
      let { task_list_id, id} = item
      bus.$emit('addTask',{ task_list_id, id })
    },
    activeTr(id){
      if(this.isCheckStatus) return
      bus.$emit('activeTr', id)
    },
    checkItem(item) {
      if(!this.isCheckStatus || item.task_level > 1) return
      this.$set(item, 'check', !item.check)
      this.set_checkTask(item.id)
      this.$emit('check')
    },
    selectLine() {
      let checkBox = []
      let tIndex = 0
      let bIndex = 0
      let doms = document.getElementsByClassName('table-line---title')
      for(let i = 0; i < doms.length; i++) {
        let doms2 = doms[i].querySelectorAll('.is-check-disabled')
        for(let j = 0; j < doms2.length; j ++) {
          if(doms2[j].dataset.check && (j === 0 || !doms2[j - 1].dataset.check)) {
            tIndex = j
          }
          if(doms2[j].dataset.check && (j === (doms2.length - 1) || !doms2[j + 1].dataset.check)) {
            bIndex = j
            checkBox.push({
              top: doms2[tIndex].offsetTop,
              height: doms2[bIndex].offsetTop - doms2[tIndex].offsetTop + doms2[bIndex].offsetHeight
            })
            checkBox.push({
              top: doms2[bIndex].offsetTop + doms2[bIndex].offsetHeight
            })
          }
        }
      }
      this.set_checkBox(checkBox)
    },
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.set_timer(setTimeout(fn, wait))
    },
    stopde(e) {
      e.stopPropagation();
    },
    async handleCommand(comm) {
      this.nowTaskListId = comm.item.task_list_id
      this.nowTaskListIndex = this.taskList.findIndex(res => res.task_list_id === comm.item.task_list_id)
      switch (comm.type) {
        case 'del':
          this.deletetask(comm.item);
          break
        case 'archive':
          this.archiveTask(comm.item);
          break
        case 'follow':
          await followApi.subscriptionTask({ task_id: comm.item.id })
          bus.$emit('updateTask', {task_id: comm.item.id, task_list_id: comm.item.task_list_id})
          this.$message({
            type: 'success',
            message: '已关注该任务',
          })
          break
        case 'unFollow':
          await followApi.unsubscribeTask({ task_id: comm.item.id })
          bus.$emit('updateTask', {task_id: comm.item.id, task_list_id: comm.item.task_list_id})
          this.$message({
            type: 'success',
            message: '取消关注任务',
          })
          break
        case 'unarchive':
          this.unarchiveTask(comm.item)
          break
        default:
          break
      }
    },
    async deletetask(temp) {
      await this.$wfAlert('warning', '确认删除任务吗？', '删除后的任务，将不再出现在工作台，你可以在回收站中对该任务进行恢复。', '移到回收站')
      await this.delTask({ task_id: temp.id })
      this.$message({
        type: "success",
        message: "删除成功!",
      });
      bus.$emit('updateTask')
    },
    async archiveTask(temp) {
      await this.$wfAlert('warning', '确认归档此任务？', '归档后的任务,将不可再编辑。你可以重新激活将任务恢复，进行编辑。', '确定')
      await this.updateStatus({ task_id: temp.id, task_stage: "已归档" })
      this.$message({
        type: "success",
        message: "归档成功",
      });
      bus.$emit('updateTask')
    },
    async unarchiveTask(temp) {
      await this.$wfAlert('warning', '确认恢复未归档该任务吗？', '恢复未归档该项目后，任务将恢复到未归档状态，可进行编辑。', '确定')
      await this.updateStatus({ task_id: temp.id, task_stage: "进行中" })
      this.$message({
        type: "success",
        message: "设置任务未归档成功",
      });
      bus.$emit('updateTask')
    },
    changeListShow(item) {
      this.$set(item, 'show', !item.show)
    },
    async dragIsCan() {
      if(this.queryMsg.sorting_rules && this.queryMsg.sorting_rules.length > 0 && this.queryMsg.sort_switch === 1) {
        await this.$wfAlert('warning', '提示', '<p>当前已设置排序规则，不可进行拖动排序功能。</p>是否关闭自定义排序再进行此操作？')
        bus.$emit('closeSortSwitch')
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
  .task-list-curr{
    .is-check {
      .table-line---item:not(.table-line---item-name), .table-line-item---in--fixed{
        &::before {
          content: '';
          position: absolute;
          left:0;
          top:0;
          bottom:0;
          right:0;
          background-color: rgba(38, 130, 255, 0.08) !important;
          z-index: 999;
        }
      }
    }
    .table-line-item---in{
      .icon-icon_enlarge{
        line-height: 1;
        font-size: 14px;
        font-weight: bold;
        visibility: hidden;
      }
      &:hover{
        .icon-icon_enlarge{
          visibility: visible;
        }
      }
      .drag-icon {
        display: inline-block;
        text-align: center;
        font-size: 14px;
        @include fontColorOpacity(.4);
        visibility: hidden;
        cursor: pointer;
        flex-shrink: 0;
      }
      .add-icon {
        @include fontColorOpacity(.6);
        display: none;
      }
      .up-arrow{
        width: 22px;
        margin-right: 8px;
        i{
          font-size: 12px;
          @include fontColorOpacity(.24);
          // margin-right: 16px;
          cursor: pointer;
        }
      }
      &:hover{
        .drag-icon{
          visibility: visible;
        }
        .add-icon {
          display: inline-block;
        }
        .task-sn-nore{
          display: block !important;
        }
      }
      i{
        line-height: 1;
      }
    }
    .table-line-item---in {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      .table-line-item---title {
        color:#202028;
        &:hover {
          color: $colorStatus_hoverColor;
        }
        .tool-tip-flex {
          width: 0;
          max-width: initial !important;
          flex: 1;
        }
      }
      span {
        cursor: pointer;
      }
      .dot {
        background: linear-gradient(225deg, #6b97cf 0%, #456fb3 100%);
        width: 6px;
        height: 6px;
        border-radius: 50%;
        flex-shrink: 0;
        position: absolute;
        left: 0px;
      }
      .task-sn {
        display: flex;
        text-align: center;
        border-radius: 2px;
        font-size: 12px;
        align-items: center;
        line-height: 1;
        i {
          color: rgba(32, 32, 32, 0.6);
        }
        .task-sn-nore {
          margin-right: 4px;
          display: none;
        }
      }
      .visibleActive-task-sn {
        display: block !important;
        i {
          background: rgba(32, 32, 32, 0.16);
        }
      }
      .add-icon {
        color: rgba(32, 32, 32, 0.6);
        font-size: 14px;
      }
    }
    // .table-line---tr {
    //   font-size: 14px;
    //   transition: all 0.3s;
    //   display: flex;
    //   &:hover {
    //     .table-line---item {
    //       background-color: #F1F2F3FF;
    //     }
    //     .task-sn {
    //       visibility: visible;
    //     }
    //   }
    // }
    // .tr-active {
    //   .table-line---item {
    //     background-color: #F1F2F3FF;
    //   }
    // }
    .table-line-item---title {
      cursor: pointer;
      display: flex;
      width: 0;
      flex: 1;
      padding-right: 4px;
      box-sizing: border-box;
      .count {
        flex-shrink: 0;
      }
    }
    .child-box .task-list-curr .child-box{
      .table-line---item  {
        border-top: 0 none !important;
      }
    }
    .readonly-style {
      &:hover {
        .table-line---item {
          background-color: #EEEEEE !important;
        }
      }
      .more-box-tip {
        background-color: #E4E4E4 !important;
        color: rgba(32, 32, 32, 0.4) !important;
        border-color: transparent !important;
      }
    }
    .tr-active {
      .table-line---item {
        background-color: #EEEEEE !important;
      }
    }
  }
  .task-list-curr__none {
    border-top: 1px solid #e7e8ed99;
  }
</style>
